module.exports = __webpack_public_path__ + "img/Wossicon.cf215437.jpg";